import { Link } from "react-router-dom";
import { categories } from "../../../mocks/categories";

export default function CategorySection() {
  const featured = categories.slice(0, 6);

  return (
    <section className="py-20 bg-[#FFF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-xs font-bold text-[#FF6B6B] uppercase tracking-widest">
              Browse by Category
            </span>
            <h2
              className="text-4xl font-extrabold text-gray-900 mt-1"
              style={{ fontFamily: "'Nunito', sans-serif" }}
            >
              What&apos;s Your Vibe Today?
            </h2>
          </div>
          <Link
            to="/categories"
            className="hidden md:flex items-center gap-2 text-sm font-bold text-[#FF6B6B] hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
          >
            All Categories <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
          {featured.map((cat, i) => (
            <Link
              key={cat.id}
              to={`/categories?cat=${cat.slug}`}
              className={`group relative overflow-hidden rounded-2xl cursor-pointer ${i === 0 ? "md:row-span-2" : ""}`}
              style={{ minHeight: i === 0 ? "360px" : "160px" }}
            >
              {/* Background Image */}
              <div className="absolute inset-0 w-full h-full">
                <img
                  src={cat.image}
                  alt={cat.label}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-br ${cat.color} opacity-80 group-hover:opacity-70 transition-opacity`} />
              </div>

              {/* Content */}
              <div className="relative z-10 h-full flex flex-col justify-between p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/20 backdrop-blur-sm">
                  <i className={`${cat.icon} text-white text-lg`} />
                </div>
                <div>
                  <h3
                    className="text-white font-extrabold text-lg leading-tight"
                    style={{ fontFamily: "'Nunito', sans-serif" }}
                  >
                    {cat.label}
                  </h3>
                  <p className="text-white/80 text-xs mt-1">
                    {cat.quizCount} quizzes
                  </p>
                </div>
              </div>

              {/* Arrow on hover */}
              <div className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white/0 group-hover:bg-white/20 transition-colors">
                <i className="ri-arrow-right-up-line text-white text-sm opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
